var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"c-form-item",class:"c-form-input-item"},[_c('label',[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"input-wrap"},[_vm._v(" "+_vm._s(_vm.value)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }